import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Arrow } from './icons'

const administrationFee = {
  personalLoan: 'Administration fee up to 9.99%.',
  securedPersonalLoan: 'Administration fee of 2.5%. State lien fees range from $4 – $95.'
}

class RateTerms extends Component {
  constructor(props) {
    super(props)

    this.state = {
      states: [],
      stateSelected: {
        disclaimers: []
      },
      isHovered: false
    }
  }

  componentDidMount() {
    this.orderData(this.props.data)
  }

  orderData = data => {
    const statesObj = data
    const stateArr = []

    Object.keys(statesObj).forEach(keys => stateArr.push(Object.assign(statesObj[keys])))

    const stateData = stateArr.reduce((acc, { state_name, products }) => {
      const { loan_amount_range, apr_range, loan_term_range, disclaimers } = products[0]

      return [
        ...acc,
        {
          name: state_name,
          loanAmount: `$${loan_amount_range[0].toLocaleString()}-$${loan_amount_range[1].toLocaleString()}`,
          loanTermRange: `${loan_term_range[0]}-${loan_term_range[1]} months`,
          aprRange: `${(apr_range[0] * 100).toFixed(2)}%-${(apr_range[1] * 100).toFixed(2)}%`,
          disclaimers
        }
      ]
    }, [])

    // alphabetize states by state name
    stateData.sort((a, b) => (a.name > b.name ? 1 : -1))

    const stateSelected = stateData[0]

    this.setState({ states: stateData, stateSelected })
  }

  handleSelectedState = name => {
    const stateSelected = this.state.states.filter(state => name === state.name)[0]

    this.setState({ stateSelected, isHovered: false })
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true })
  }

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
  }

  render() {
    const {
      states,
      stateSelected: { name, loanAmount, aprRange, loanTermRange, disclaimers },
      isHovered
    } = this.state

    const { changeLayout, type } = this.props
    const unsecuredCovidAffectedStates = ['Hawaii']
    const securedCovidAffectedStates = ['Hawaii', 'Florida']
    const suppressedStates = ['New York', 'Iowa', 'Vermont', 'West Virginia']
    const isStateSuppressedOrCovidAffected =
      this.props.type === 'securedPersonalLoan'
        ? securedCovidAffectedStates.indexOf(this.state.stateSelected.name) >= 0 ||
          suppressedStates.indexOf(this.state.stateSelected.name) >= 0
        : unsecuredCovidAffectedStates.indexOf(this.state.stateSelected.name) >= 0 ||
          suppressedStates.indexOf(this.state.stateSelected.name) >= 0

    return (
      <section className="rates-terms">
        <div className="container__inner">
          <div className="rates-terms__heading-box">
            <h5 className="datapoints">
              {changeLayout ? (
                <>
                  Rates and terms <br /> for the state of &nbsp;
                </>
              ) : (
                <>Rates and terms for the state of &nbsp;</>
              )}
              <div
                className="rates-terms__state"
                onClick={this.handleMouseEnter}
                onKeyPress={this.handleMouseEnter}
                role="presentation"
              >
                {name}
                <Arrow className="rates-terms__icon" width={32} height={18} />

                <div
                  className={`rates-terms__dropdown ${
                    isHovered ? 'rates-terms__dropdown--show' : ''
                  }`}
                  onMouseLeave={this.handleMouseLeave}
                  aria-hidden="true"
                >
                  <p className="rates-terms__dropdown-header">Select one...</p>
                  <div className="rates-terms__list-box">
                    <ul className="rates-terms__list">
                      {/* eslint-disable no-shadow */}
                      {states.map(({ name }) => (
                        <li className="rates-terms__item" key={name}>
                          <p
                            className="rates-terms__text"
                            onClick={e => {
                              this.handleSelectedState(e.target.innerHTML)
                              e.stopPropagation()
                            }}
                            onKeyPress={e => {
                              this.handleSelectedState(e.target.innerHTML)
                              e.stopPropagation()
                            }}
                            role="presentation"
                          >
                            {name}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="rates-terms__arrow" />
                </div>
              </div>
            </h5>
            <label className="hide-display" htmlFor="state-selected">
              Choose a state:
            </label>
            <select
              className="hide-display"
              id="state-selected"
              aria-describedby={name}
              name="stateSelected"
              value={name}
              onChange={e => this.handleSelectedState(e.target.value)}
            >
              {states.map(({ name }) => (
                <option value={name} key={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
          {isStateSuppressedOrCovidAffected ? (
            <div className="rates-terms__covid-alert-content-box">
              <div className="rates-terms__covid-alert">
                <span className="rates-terms__covid-alert-underlined">
                  Applications for residents in the state of {this.state.stateSelected.name} are not
                  currently accepted.
                </span>
              </div>
            </div>
          ) : (
            <div className="rates-terms__content-box">
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">loan amount ranges</h5>
                <p className="datapoints--terms">{loanAmount}</p>
              </div>
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">loan term ranges</h5>
                <p className="datapoints--terms">{loanTermRange}</p>
              </div>
              <div className="rates-terms__text-box">
                <h5 className="datapoints-sub">apr ranges</h5>
                <p className="datapoints--terms">{aprRange}</p>
              </div>
            </div>
          )}
          <div className="rates-terms__disclaimer-box">
            {disclaimers.map(text => (
              <p className="rates-terms__disclaimer" key={`${text} ${new Date().getTime()}`}>
                {text}
              </p>
            ))}
            <p className="rates-terms__disclaimer">{administrationFee[type]}</p>
          </div>
        </div>
      </section>
    )
  }
}

RateTerms.defaultProps = {
  changeLayout: false
}

RateTerms.propTypes = {
  changeLayout: PropTypes.bool,
  type: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
}

export default RateTerms
